import { render } from "./ScheduleAdmin.vue?vue&type=template&id=2a96a65c&scoped=true"
import script from "./ScheduleAdmin.vue?vue&type=script&lang=js"
export * from "./ScheduleAdmin.vue?vue&type=script&lang=js"

import "./ScheduleAdmin.vue?vue&type=style&index=0&id=2a96a65c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a96a65c"]])

export default __exports__